import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { MapPin, Sparkles } from "lucide-react";

// Complétion du profil après un 1er login Google : ville + code postal pour la géoloc des bons plans.
// Étape facultative : l'utilisateur peut passer et compléter plus tard depuis son compte.
export default function WelcomeGoogle() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [saving, setSaving] = useState(false);

  // Déjà renseigné ou non concerné → on file au compte.
  if (user && user !== false && (user.city || "").trim()) {
    navigate("/compte", { replace: true });
    return null;
  }

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/auth/me", { city: city.trim(), postal_code: postal.trim() });
      await refresh();
      toast.success("Merci ! Vos bons plans locaux sont prêts.");
      navigate("/compte", { replace: true });
    } catch {
      toast.error("Impossible d'enregistrer pour le moment.");
      setSaving(false);
    }
  };

  const skip = () => navigate("/compte", { replace: true });

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="welcome-google-page">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-50 border border-orange-200 text-[#E05638] text-xs font-bold">
        <Sparkles size={13} /> Bienvenue sur PROXIreduc-28
      </div>
      <h1 className="font-heading text-2xl font-extrabold mt-3">Où êtes-vous ?</h1>
      <p className="mt-2 text-sm text-slate-600">
        Indiquez votre ville pour recevoir les <strong>bons plans les plus proches de chez vous</strong>. Vous pourrez modifier cela à tout moment.
      </p>

      <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-6 space-y-4">
        <div>
          <Label>Ville</Label>
          <div className="mt-1 relative">
            <MapPin size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Chartres, Dreux, Châteaudun…" className="pl-9" data-testid="welcome-google-city" />
          </div>
        </div>
        <div>
          <Label>Code postal</Label>
          <Input value={postal} onChange={(e) => setPostal(e.target.value)} placeholder="28000" data-testid="welcome-google-postal" />
        </div>
        <Button onClick={save} disabled={saving || !city.trim()} className="w-full btn-shine text-white h-11" data-testid="welcome-google-save">
          {saving ? "Enregistrement…" : "Enregistrer et voir mes bons plans"}
        </Button>
        <button onClick={skip} className="w-full text-sm text-slate-500 hover:text-slate-800" data-testid="welcome-google-skip">
          Plus tard
        </button>
      </div>
    </div>
  );
}
